import { showEventTime } from "../../function/common";
import { CiAlarmOn, CiHashtag, CiMap, CiTextAlignLeft } from "react-icons/ci";
import { PiProjectorScreenChartLight, PiUser, PiUsersFour } from "react-icons/pi";
import { DetailContainer } from "../../styled/scheduler";
import { useNavigate } from "react-router";
import moment from "moment";
import Memo from "./report/memo";
import { useSelector } from "react-redux";

const Detail = ({ eventInfo, isSchedule, todos, setTodos, setActive }) => {
  const navigate = useNavigate();

  const headers = [
    {
      label: "날짜",
      icon: CiAlarmOn,
      render: true,
      content: isSchedule
        ? showEventTime(eventInfo.startDt, eventInfo.endDt)
        : moment(eventInfo.startDt).format("YYYY년 M월 D일"),
      key: "date",
    },
    {
      label: "위치",
      render: isSchedule,
      icon: CiMap,
      content: eventInfo.place || eventInfo.placeDetail || "-",
      key: "place",
    },
    {
      label: "프로젝트",
      icon: PiProjectorScreenChartLight,
      render: eventInfo.gbn !== "P" && eventInfo.projectNo > 0,
      content: (
        <span
          onClick={() => navigate(`/mypage/project/${eventInfo.projectNo}`)}
          style={{ cursor: "pointer" }}>
          {eventInfo.projectNm}
        </span>
      ),
      key: "project",
    },
    {
      label: "종류",
      icon: CiHashtag,
      render: eventInfo.gbn !== "P" && eventInfo.projectNo > 0 && eventInfo.certainType,
      content: <span>{eventInfo.certainType}</span>,
      key: "certainType",
    },
    {
      label: eventInfo.gbn === "C" ? "담당자" : eventInfo?.gbn === "P" ? "작성자" : "주최자",
      icon: PiUsersFour,
      render: eventInfo.managerNm,
      content: eventInfo.managerNm || "-",
      key: "manager",
    },
    {
      label: eventInfo.gbn === "C" ? "실무자" : "참여자",
      icon: PiUser,
      render: Object.keys(eventInfo.workerList ?? {}).length,
      content: Object.entries(eventInfo.workerList ?? {}).map(([key, worker], i, arr) => (
        <span key={key}>
          {worker}
          {i < arr.length - 1 && ", "}
        </span>
      )),
      key: "workers",
    },
  ].filter(Boolean);

  return (
    <DetailContainer className="detail">
      <ul>
        {headers
          .filter((item) => item.render)
          .map(({ label, icon: Icon, content }, index) => (
            <li key={index}>
              <div className="tit">
                <i className="icon">
                  <Icon />
                </i>
                <span>{label}</span>
              </div>
              <div className="cont">{content}</div>
            </li>
          ))}
        <li className="eventMemo">
          <div className="tit">
            <i className="icon">
              <CiTextAlignLeft />
            </i>
            <span>메모</span>
          </div>
          <div className="cont">
            <Memo eventInfo={eventInfo} setTodos={setTodos} todos={todos} setActive={setActive} />
          </div>
        </li>
      </ul>
    </DetailContainer>
  );
};

export default Detail;
